// goalUtils.js

import { calculateMonthlySIP } from "./sipUtils"; // Make sure this import is correct

export function calculateSIPDeficit(accumulated, goal) {
  if (goal.monthlysaving) {
    const currentTime = new Date();
    const targetYear = Number(goal.targetYear ||goal.goalYear || 0);
    const startYear = Number(goal.startyear || 0);
    const monthsLeft = (targetYear - startYear) * 12;
    // console.log('targetYear',startYear,targetYear);

    const targetAmount = Number(goal.targetAmount || 0);
    const staticCAGR = Number(goal.targetReturn || 0);
    const timeline = Number(goal.timeline || monthsLeft / 12);
    let runningSIP = Number(goal.runningSIP || 0);
    const accumulatedVal = Number(accumulated || 0);

    const sipForTarget = calculateMonthlySIP(
      targetAmount,
      staticCAGR,
      timeline
    );

    // years remain
    // const testMonths = goal?.yearsRemain
    // Goal Timeline (Years)  after map years remain changed to Goal Timeline (Years) 
    const testMonths = (targetYear - currentTime.getFullYear()) * 12;
    // console.log('testMonths',testMonths,(targetYear-currentTime.getFullYear())*12,targetYear,currentTime.getFullYear(),goal?.yearsRemain);
    

    if (runningSIP !== 0 || accumulatedVal !== 0) {
      let monthEndVal = 0;

      for (let i = 1; i < testMonths; i++) {
        const capitalGrow = ((monthEndVal + runningSIP) * staticCAGR) / 1200;
        monthEndVal += capitalGrow + runningSIP;
      }

      monthEndVal += runningSIP;

      const accumFutureVal =
        accumulatedVal *
        Math.pow(1 + staticCAGR / 100, targetYear - currentTime.getFullYear());

      const futureVal = Math.round(monthEndVal) + accumFutureVal;
      const remainingVal = targetAmount - futureVal;

      // let requiredSIP = 0;

      //   if (testMonths <= 0) {
      //     requiredSIP = remainingVal; // lump sum required
      //     console.log('requiredSIP',requiredSIP,remainingVal,staticCAGR,testMonths,((remainingVal * (staticCAGR / 1200)),(Math.pow(1 + staticCAGR / 1200, testMonths) - 1)));
      //   } else if (staticCAGR === 0) {
      //     requiredSIP = remainingVal / testMonths;
          
      //   } else {
      //     requiredSIP =
      //       (remainingVal * (staticCAGR / 1200)) /
      //       (Math.pow(1 + staticCAGR / 1200, testMonths) - 1);
      //   }

      const requiredSIP =(remainingVal * (staticCAGR / 1200)) /(Math.pow(1 + staticCAGR / 1200, testMonths) - 1);
      console.log('requiredSIP',requiredSIP,(remainingVal * (staticCAGR / 1200)),(Math.pow(1 + staticCAGR / 1200, testMonths) - 1));
      // console.log(
      //   `🧾 SIP Calc → Target: ₹${targetAmount}, Accum: ₹${accumulatedVal}, Start: ${startYear}, Target: ${targetYear}, MonthsLeft: ${monthsLeft}, CAGR: ${staticCAGR}%, RunningSIP: ₹${runningSIP}, SIP(Target): ₹${sipForTarget.toFixed(
      //     2
      //   )}, FutureVal: ₹${futureVal.toFixed(
      //     2
      //   )}, Remaining: ₹${remainingVal.toFixed(
      //     2
      //   )}, RequiredSIP: ₹${requiredSIP.toFixed(2)}`
      // );
          console.log('requiredSIP', remainingVal,staticCAGR, testMonths);


      return requiredSIP;
    } else {
      return 0;
    }
  }
}


// mobile
// export const calculateSIPDeficit = (accumulated, goal) => {

//           console.log('requiredSIP', accumulated, goal);

//     if (goal.monthlysaving) {
     
//       const currentTime = new Date();
//       const targetYear = Number(goal.targetYear || 0);
//       const startYear = Number(goal.startyear || 0);
//       const monthsLeft = (targetYear - startYear) * 12;

//       const targetAmount = Number(goal.targetAmount || 0);
//       const staticCAGR = Number(goal.targetReturn || 0);
//       const timeline = Number(goal.yearsRemain || monthsLeft / 12);
//       let runningSIP = Number(goal.runningSIP || 0);
//       const accumulatedVal = Number(accumulated || 0);

//       const testMonths = (targetYear - currentTime.getFullYear()) * 12;


//       if (runningSIP !== 0 || accumulatedVal !== 0) {
//         let monthEndVal = 0;

//         for (let i = 1; i < testMonths; i++) {
//           const capitalGrow = ((monthEndVal + runningSIP) * staticCAGR) / 1200;
//           monthEndVal += capitalGrow + runningSIP;
//         }

//         monthEndVal += runningSIP;

//         const accumFutureVal =
//           accumulatedVal *
//           Math.pow(1 + staticCAGR / 100, targetYear - currentTime.getFullYear());

//         const futureVal = Math.round(monthEndVal) + accumFutureVal;
//         const remainingVal = targetAmount - futureVal;

//         const requiredSIP =
//           (remainingVal * (staticCAGR / 1200)) /
//           (Math.pow(1 + staticCAGR / 1200, testMonths) - 1);

//           console.log('requiredSIP', remainingVal,staticCAGR, testMonths);


//         return requiredSIP;
//       } else {
//         return 0;
//       }
//     }
//   }
